
'use client';

export default function Modalcomponent({openModal,setOpenModal,pdf}) {
  if (!openModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={() => setOpenModal(false)} />
      <div className="relative z-10 bg-white rounded-lg shadow-xl w-full max-w-7xl mx-4">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold flex items-center">
            <box-icon name='universal-access'></box-icon>&nbsp;Vista previa
          </h3>
          <button onClick={() => setOpenModal(false)} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
        </div>
        <div className='bg-black w-full'>
          <iframe className='w-full h-screen' src={pdf}></iframe>
        </div>
      </div>
    </div>
  );
}
